import { render, staticRenderFns } from "./BookingReview.vue?vue&type=template&id=4ddc6b33&scoped=true&"
import script from "./BookingReview.vue?vue&type=script&lang=js&"
export * from "./BookingReview.vue?vue&type=script&lang=js&"
import style0 from "./BookingReview.vue?vue&type=style&index=0&id=4ddc6b33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddc6b33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ddc6b33')) {
      api.createRecord('4ddc6b33', component.options)
    } else {
      api.reload('4ddc6b33', component.options)
    }
    module.hot.accept("./BookingReview.vue?vue&type=template&id=4ddc6b33&scoped=true&", function () {
      api.rerender('4ddc6b33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/BookingReview.vue"
export default component.exports